export default class EditMessageboxFolder {
  constructor(elem) {
    this.elem = elem;
    this.folders = [...this.elem.querySelectorAll('[data-folder]')];

    this.init();
  }

  init() {
    if (this.folders.length) {
      // this._renameFolder();
      this._renameFolder2();
      // this._deleteFolder();
      this._deleteFolder2();
    }
  }

  _renameFolder() {
    this.folders.forEach(folder => {
      const $folderRename = folder.querySelector(
        '[data-folder-action="rename"]'
      );
      const $folderCancel = folder.querySelector(
        '[data-folder-action="cancel"]'
      );
      const $folderLink = folder.querySelector('.js-folder-link');
      const $form = folder.querySelector('.js-inplace-edit');

      $folderRename.addEventListener(
        'click',
        e => {
          e.preventDefault();

          $folderLink.style.display = 'none';
          $form.style.display = '';

          e.target.style.display = 'none';
          $folderCancel.style.display = '';
        },
        false
      );

      $folderCancel.addEventListener(
        'click',
        e => {
          e.preventDefault();

          $form.style.display = 'none';
          $folderLink.style.display = '';

          e.target.style.display = 'none';
          $folderRename.style.display = '';
        },
        false
      );
    });
  }

  _deleteFolder() {
    this.folders.forEach(folder => {
      const $folderPopover = folder.querySelector(
        '[data-folder-action="popover"]'
      );

      const $folderId = $folderPopover.getAttribute('data-folder-id');
      // const $folderName = $folderPopover.getAttribute('data-folder-name');
      const $buttonLabel = $folderPopover.getAttribute('data-button-label');
      const $folderMessage = $folderPopover.getAttribute('data-folder-message');
      const $folderMessageClean = $folderMessage.replace(/\\/gi, '');

      // Create temp container element for the delete button
      const $deleteCtn = document.createElement('div');
      // Create the delete button
      const $deleteBtn = document.createElement('button');
      const deleteBtnLabel = document.createTextNode($buttonLabel);
      $deleteBtn.setAttribute('type', 'button');
      $deleteBtn.setAttribute('data-folder-action', 'delete');
      $deleteBtn.classList.add('btn', 'btn-danger');
      // Put everything into its box
      $deleteBtn.appendChild(deleteBtnLabel);
      $deleteCtn.appendChild($deleteBtn);

      $($folderPopover).popover({
        content: $folderMessageClean,

        html: true,

        placement: 'left',

        template: `<div class="popover" role="tooltip">
                     <div class="arrow"></div>
                     <div class="popover-content"></div>
                     <div class="popover-action">
                       ${$($deleteCtn).html()}
                     </div>
                   </div>`
      });

      $folderPopover.addEventListener(
        'click',
        e => {
          e.preventDefault();
        },
        false
      );

      folder.addEventListener(
        'click',
        e => {
          if (e.target.getAttribute('data-folder-action') === 'delete') {
            const data = {
              ordner: $folderId,

              del: 'true',

              really_del: 'true',

              ajaxed: 'true'
            };

            // Send data to server
            const request = $.ajax({
              url: `messagebox_ordner.php?t=${Date.now()}`,

              type: 'POST',

              data
            });

            request.done(() => {
              window.location.href = '/messagebox_ordner.php';
            });

            request.fail(jqXHR => {
              const $domAnchor = $(folder).find('td');
              const $errorContainer = document.createElement('div');
              const errorMessage = document.createTextNode(
                `${jqXHR.status}: ${jqXHR.statusText}`
              );

              // Append error message to error container
              $errorContainer.appendChild(errorMessage);
              // Add bootstarp alert styles to error container
              $errorContainer.classList.add('alert', 'alert-danger');
              // Add the error container to the DOM
              $domAnchor.prepend($errorContainer);
            });
          }
        },
        false
      );
    });
  }

  _renameFolder2() {
    this.folders.forEach(folder => {
      const $folderRename = folder.querySelector(
        '[data-folder-action="rename"]'
      );
      const $folderDel = folder.querySelector('.js-inplace-remove');
      const $folderCancel = folder.querySelector(
        '[data-folder-action="cancel"]'
      );

      // console.log($folderRename);
      // console.log($folderCancel);

      const $folderLink = folder.querySelector('.js-folder-link');
      const $form = folder.querySelector('.js-inplace-edit');
      const $oldRenameInput = folder.querySelector('input[name="foldername"]');
      const $oldRenameValue = $oldRenameInput.value;
      // console.log('$oldRenameValue');
      // console.log($oldRenameValue);

      $folderRename.addEventListener(
        'click',
        e => {
          // console.log('UNO');
          // console.log(e.target.tagName);
          // console.log(e.currentTarget.tagName);
          e.preventDefault();

          $folderLink.style.display = 'none';
          $form.style.display = '';

          // e.target.style.display = 'none';
          e.currentTarget.style.display = 'none';
          $folderCancel.style.display = '';
          $folderDel.style.display = 'none';
        },
        false
      );

      $folderCancel.addEventListener(
        'click',
        e => {
          e.preventDefault();

          $form.style.display = 'none';
          $folderLink.style.display = '';

          e.currentTarget.style.display = 'none';
          $folderRename.style.display = '';
          $oldRenameInput.value = $oldRenameValue;
        },
        false
      );
    });
  }

  _deleteFolder2() {
    this.folders.forEach(folder => {
      const $folderPopover = folder.querySelector(
        '[data-folder-action="popover"]'
      );

      // console.log(folder);

      const $folderId = $folderPopover.getAttribute('data-folder-id');
      // const $folderName = $folderPopover.getAttribute('data-folder-name');
      // const $buttonLabel = $folderPopover.getAttribute('data-button-label');
      // const $folderMessage = $folderPopover.getAttribute('data-folder-message');
      // const $folderMessageClean = $folderMessage.replace(/\\/gi, '');

      // console.log($folderMessageClean);

      // Create temp container element for the delete button
      // const $deleteCtn = document.createElement('div');
      // Create the delete button
      // const $deleteBtn = document.createElement('button');
      // const deleteBtnLabel = document.createTextNode($buttonLabel);
      // $deleteBtn.setAttribute('type', 'button');
      // $deleteBtn.setAttribute('data-folder-action', 'delete');
      // $deleteBtn.classList.add('btn', 'btn-danger');
      // Put everything into its box
      // $deleteBtn.appendChild(deleteBtnLabel);
      // $deleteCtn.appendChild($deleteBtn);

      $folderPopover.addEventListener(
        'click',
        e => {
          e.preventDefault();
          // console.log(e);
        },
        false
      );

      folder.addEventListener(
        'click',
        e => {
          let action = '';
          if (e.target.tagName === 'I') {
            // console.log('estoy en I also get parent a');
            action = e.target.parentElement.getAttribute('data-folder-action');
          } else if (e.target.tagName === 'A') {
            // console.log('estoy en A also get this');
            action = e.target.getAttribute('data-folder-action');
          } else if (e.target.tagName === 'BUTTON') {
            // console.log('estoy en BUTTON also get this');
            action = !e.target.getAttribute('data-folder-action')
              ? 'cancel'
              : e.target.getAttribute('data-folder-action');
          }
          const $folderRen = folder.querySelector(
            '[data-folder-action="rename"]'
          );
          const $folderCancel = folder.querySelector(
            '[data-folder-action="cancel"]'
          );
          // console.log('clicked:');
          // console.log(e.target.tagName);
          // console.log(e.currentTarget.tagName);
          // console.log('action es:');
          // console.log(action);
          if (action === 'cancel') {
            // console.log('ensena el formulario');
            const $delForm = folder.querySelector('.js-inplace-remove');
            $delForm.style.display = 'none';
            $folderCancel.style.display = 'none';
            $folderRen.style.display = '';
          }
          if (action === 'popover') {
            // console.log('ensena el formulario');
            const $delForm = folder.querySelector('.js-inplace-remove');
            const $renForm = folder.querySelector('.js-inplace-edit');
            const $renLink = folder.querySelector('.js-folder-link');
            $delForm.style.display = '';
            $renLink.style.display = '';
            $renForm.style.display = 'none';
            $folderCancel.style.display = 'none';
            $folderRen.style.display = '';
          }
          // if (e.target.getAttribute('data-folder-action') === 'delete') {
          if (action === 'delete') {
            // console.log('llegue a delete');
            const data = {
              ordner: $folderId,

              del: 'true',

              really_del: 'true',

              ajaxed: 'true'
            };

            const $pause = 3;
            if ($pause === 3) {
              // Send data to server
              const request = $.ajax({
                url: `messagebox_ordner.php?t=${Date.now()}`,

                type: 'POST',

                data
              });

              request.done(() => {
                window.location.href = '/messagebox_ordner.php';
              });

              request.fail(jqXHR => {
                const $domAnchor = $(folder).find('td');
                const $errorContainer = document.createElement('div');
                const errorMessage = document.createTextNode(
                  `${jqXHR.status}: ${jqXHR.statusText}`
                );

                // Append error message to error container
                $errorContainer.appendChild(errorMessage);
                // Add bootstarp alert styles to error container
                $errorContainer.classList.add('alert', 'alert-danger');
                // Add the error container to the DOM
                $domAnchor.prepend($errorContainer);
              });
            }
          }
        },
        false
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/edit_messagebox_folder.js